module.exports = __webpack_public_path__ + "static/img/main-navigation-icon04.aae0aa06.svg";